export default __webpack_public_path__ + "static/media/kafka.5aa3159d.png";